import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './App.css';

// Import components
import MapView from './components/Map/MapView';
import Navigation from './components/Navigation/Navigation';
import JJMuseModal from './components/JJMuse/JJMuseModal';
import ChatInterface from './components/Chat/ChatInterface';

// Create theme with purple accent color
const theme = createTheme({
  palette: {
    primary: {
      main: '#9C27B0', // Purple accent color
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  shape: {
    borderRadius: 12, // Rounded corners throughout the interface
  },
  shadows: [
    'none',
    '0px 2px 4px rgba(0, 0, 0, 0.1)', // Soft shadows for elevated elements
    // ... rest of shadows
  ],
});

function App() {
  const [showJJMuse, setShowJJMuse] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [activated, setActivated] = useState(false);
  const [currentView, setCurrentView] = useState('map'); // Default view is map
  const [preventAccidentalTrigger, setPreventAccidentalTrigger] = useState(true); // Prevent accidental triggers by default

  // Handle press and hold to activate JJ Muse
  const handlePressAndHold = () => {
    // Only allow press and hold activation if accidental triggers are not being prevented
    if (!preventAccidentalTrigger) {
      if (!activated) {
        setShowJJMuse(true);
      } else {
        setShowChat(true);
      }
    }
  };

  // Handle JJ Muse activation
  const handleActivate = () => {
    setActivated(true);
    setShowJJMuse(false);
    setShowChat(true);
  };

  // Handle closing the chat interface
  const handleCloseChat = () => {
    setShowChat(false);
  };

  // Handle navigation bar click - this enables the JJMuse button
  const handleNavBarClick = () => {
    // When the nav bar is clicked, temporarily enable JJMuse button
    setPreventAccidentalTrigger(false);
    
    // Re-enable prevention after a short delay to prevent accidental triggers
    setTimeout(() => {
      setPreventAccidentalTrigger(true);
    }, 3000); // 3 seconds window to use JJMuse button
  };

  // Handle navigation button clicks
  const handleNavigation = (navItem) => {
    // Update current view
    setCurrentView(navItem);

    if (navItem === 'jjmuse') {
      if (!activated) {
        setShowJJMuse(true);
      } else {
        setShowChat(true);
      }
    }
    // Handle other navigation items as needed
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={
              <>
                <MapView onPressAndHold={handlePressAndHold} />
                <Navigation 
                  onNavigate={handleNavigation} 
                  preventAccidentalTrigger={preventAccidentalTrigger}
                  currentView={currentView}
                  onNavBarClick={handleNavBarClick}
                />
                {showJJMuse && !activated && (
                  <JJMuseModal onActivate={handleActivate} onClose={() => setShowJJMuse(false)} />
                )}
                {showChat && activated && (
                  <ChatInterface onClose={handleCloseChat} />
                )}
              </>
            } />
            {/* Add more routes as needed */}
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
